import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const idTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Nama (huruf kecil, tanpa karakter khusus)',
    add: 'Tambahkan',
    allowedFileTypes: 'Jenis File yang Diizinkan',
    allowedFileTypesDescription:
      'Batasi jenis file yang diperbolehkan (mis., gambar/*, aplikasi/pdf). Biarkan kosong untuk mengizinkan semua jenis.',
    allowMultipleFiles: 'Izinkan Banyak File',
    amountInCents: 'Jumlah dalam sen',
    basePrice: 'Harga Dasar',
    bcc: 'SMK',
    brand: 'Merek',
    cc: 'CC',
    checkboxPlural: 'Bidang Kotak Centang',
    checkboxSingular: 'kotak centang',
    checkedByDefault: 'Diperiksa secara default',
    chooseConfirmationType:
      'Pilih apakah akan menampilkan pesan di halaman atau mengalihkan ke halaman lain setelah mereka mengirimkan formulir.',
    condition: 'Kondisi',
    confirmationMessage: 'Pesan Konfirmasi',
    confirmationType: 'Jenis Konfirmasi',
    countryPlural: 'Bidang Negara',
    countrySingular: 'Negara',
    creditCard: 'Kartu Kredit',
    customURL: 'URL khusus',
    datePlural: 'Bidang Tanggal',
    dateSingular: 'Tanggal',
    defaultValue: 'Nilai Bawaan',
    divide: 'Bagilah',
    documentToLinkTo: 'Dokumen untuk ditautkan',
    doesNotEqual: 'Tidak Sama',
    emailFrom: 'Email Dari',
    emailPlural: 'Bidang Email',
    emailsDescription:
      'Kirim email khusus saat formulir dikirimkan. Gunakan daftar yang dipisahkan koma untuk mengirim email yang sama ke beberapa penerima. Untuk mereferensikan nilai dari formulir ini, gabungkan nama bidang tersebut dengan tanda kurung kurawal ganda, yaitu {{firstName}}. Anda dapat menggunakan wildcard {{*}} untuk menampilkan semua data dan {{*:table}} untuk memformatnya sebagai tabel HTML di email.',
    emailSingular: 'Surel',
    emailTo: 'Email Ke',
    equals: 'Setara',
    field: 'Bidang',
    fields: 'bidang',
    fieldWidth: 'Lebar Bidang (persentase)',
    hasAnyValue: 'Memiliki Nilai Apapun',
    internalLink: 'Tautan internal',
    label: 'Label',
    maxFileSize: 'Ukuran File Maks (byte)',
    maxFileSizeDescription: 'Ukuran file maksimum dalam byte. Biarkan kosong tanpa batas.',
    message: 'Pesan',
    messageDescription: 'Masukkan pesan yang harus dikirim dalam email ini.',
    messagePlural: 'Blok Pesan',
    messageSingular: 'Pesan',
    mimeType: 'Tipe MIME',
    mimeTypePlural: 'Jenis MIME',
    mimeTypeSingular: 'Tipe MIME',
    multiply: 'Lipat gandakan',
    numberPlural: 'Bidang Angka',
    numberSingular: 'Nomor',
    optionPlural: 'Pilihan',
    optionSingular: 'Pilihan',
    paymentFieldPlural: 'Bidang Pembayaran',
    paymentFieldSingular: 'Pembayaran',
    paymentProcessor: 'Pemroses Pembayaran',
    paymentStatus: 'Status',
    placeholder: 'Penampung',
    priceConditions: 'Kondisi Harga',
    priceConditionsPlural: 'Kondisi Harga',
    priceConditionsSingular: 'Kondisi Harga',
    radioOptions: 'Opsi Atribut Radio',
    radioPlural: 'Bidang Radio',
    radioSingular: 'Radio',
    redirect: 'Pengalihan',
    replyTo: 'Membalas Ke',
    required: 'Diperlukan',
    selectOptions: 'Pilih Opsi',
    selectPlural: 'Pilih Bidang',
    selectSingular: 'Pilih',
    statePlural: 'Bidang Negara',
    stateSingular: 'Negara',
    staticValue: 'Nilai Statis',
    subject: 'Subyek',
    submitButton: 'Kirim Label Tombol',
    subtract: 'Kurangi',
    textareaPlural: 'Bidang Area Teks',
    textareaSingular: 'Area teks',
    textPlural: 'Bidang Teks',
    textSingular: 'Teks',
    title: 'Judul',
    token: 'tanda',
    uploadCollection: 'Unggah Koleksi',
    uploadCollectionDescription: 'Pilih koleksi unggahan mana yang akan menyimpan file',
    uploadFieldPlural: 'Unggah Bidang',
    uploadFieldSingular: 'Unggah',
    urlToRedirectTo: 'URL tujuan pengalihan',
    value: 'Nilai',
    valueOfField: 'Nilai Bidang',
    valueType: 'Jenis Nilai',
  },
}

export const id: PluginLanguage = {
  dateFNSKey: 'id',
  translations: idTranslations,
}
